module.exports = __webpack_public_path__ + "media/images/tyre-guide_old-65d441f93da5c4fbc27398a6329460e2.jpg";